// extracted by mini-css-extract-plugin
module.exports = {"container":"Cg","list":"Dg"};